import React, { Component } from 'react';
import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

class WorkOrders extends Component {
  componentDidMount() {
    this.props.reload()
  }

  formatRequestedDate = (requestedDate) => {
    const parsedDate = Number(requestedDate)

    if (Number.isNaN(parsedDate)) {
      return ''
    }

    return new Date(parsedDate).toLocaleDateString(navigator.language)
  }

  render() {
    return (
      <div>
        <AppBar position="fixed"
          style={{
            marginLeft: 260,
            backgroundColor: '#55565A'
          }}>
          <Toolbar>
            <Typography variant="h5" style={{ marginLeft: 260 }}>
              View Work Orders
            </Typography>
          </Toolbar>
        </AppBar>
        <Paper position="fixed" style={{
          marginTop: 60,
          paddingTop: 30,
          height: 120,
          marginLeft: 260
        }}>
          <Typography variant="h6" style={{ marginLeft: 30, align: 'left' }}>
            {this.props.loginInfo ? this.props.loginInfo.username : ''}
          </Typography>
          <Typography variant="body2" style={{ marginLeft: 30, align: 'left' }}>
            Note: Assigned Technicians will be named via WhatsApp.
          </Typography>
        </Paper>
        <Paper style={{
          marginLeft: 260,
          marginBottom: 60
        }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Requested date</TableCell>
                <TableCell>Number</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.workOrders.map((workOrder, index) => {
                return (
                  <TableRow key={workOrder.numeroOrden || index}>
                    <TableCell>{this.formatRequestedDate(workOrder.fechaPedido)}</TableCell>
                    <TableCell>{workOrder.numeroOrden}</TableCell>
                    <TableCell>{workOrder.tipoObjeto}</TableCell>
                    <TableCell>{workOrder.estado}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Paper>
      </div>
    )
  }
}

export default WorkOrders